export const Urls = {
  Authentication: '/bootstrap/start',
  Builder: '/carousel-content',
};

export const CarouselBuilderHeaders = {
  Authentication: 'x-bootstrap-authorization',
};
